import { DesignSystem, DesignSystemAccessMode, ObjectMeta, WorkspaceRoleSchema, } from "@supernova-studio/model";
import { DTOFileReference } from "../files";
import { DTODesignSystemListViewItem } from "./user-ds-preferences";
import { DTODesignSystemMembersUpdatePayload } from "./members";
import { DTODesignSystemRole } from "./role";
import { z } from "zod";
//
// Read
//
export const DTODesignSystem = DesignSystem.omit({
    name: true,
    description: true,
    docExporterId: true,
    sharedDraftId: true,
    iconFilePath: true,
}).extend({
    meta: ObjectMeta,
    docExporterId: z.string(),
    sources: z.array(z.any()),
    isPublic: z.literal(true),
    sharedDraftId: z.string(),
    icon: DTOFileReference.optional(),
    /**
     * Whether or not user who is requesting the design system
     * has access to the design system's contents.
     */
    isAvailableToUser: z.boolean(),
    /**
     * @deprecated
     */
    role: WorkspaceRoleSchema.optional(),
    /**
     * User's role within the design system that can come either from
     * the design system or workspace.
     */
    effectiveRole: DTODesignSystemRole.optional(),
});
export const DTODesignSystemResponse = z.object({
    designSystem: DTODesignSystem,
});
export const DTODesignSystemsListResponse = z.object({
    designSystems: DTODesignSystem.array(),
    designSystemListView: DTODesignSystemListViewItem.array().optional(),
});
//
// Write
//
export const DTODesignSystemCreateInput = z.object({
    workspaceId: z.string(),
    meta: ObjectMeta.optional(),
    name: z.string().min(2).max(64).optional(),
    description: z.string().max(1024).optional(),
    accessMode: DesignSystemAccessMode.optional(),
    iconFileId: z.string().optional(),
    invites: DTODesignSystemMembersUpdatePayload.pick({
        usersToInvite: true,
        invitesToInvite: true,
        emailsToInvite: true,
    }).optional(),
});
